export const LANGS = [{
    id: 1, lang: "english", text: {
        toDoList: "TO DO LIST",
        memoGame: "MEMO GAME",
        newGame: "NEW GAME",
        bestScore: "BEST SCORE",
        completed: "COMPLETED",
        turns: "TURNS",
        reset: "RESET",
        add: "ADD",
        newTask: "NEW TASK",
        deleteTask: "DELETE TASK",
        deletePic: "DELETE PICTURE",
        cancel: "CANCEL",
        delete: "DELETE",
        email: "E-MAIL",
        password: "PASSWORD",
        name: "NAME",
        avatar: "AVATAR",
        language: "LANGUAGE",
        darkMode: "DARK MODE",
        active: "ON",
        inactive: "OFF",
        colorTheme: "COLOR THEME",
        apps: "APPS",
        config: "CONFIG",
        profile: "PROFILE",
        spanish: "SPANISH",
        english: "ENGLISH",
        purple: "PURPLE",
        orange: "ORANGE",
        logIn: "LOG IN",
        logOut: "LOG OUT",
        signUp: "REGISTER",
        minEmail: "EXAMPLE@DOMAIN.COM",
        minPassword: "8 CHARACTERS MINIMUM",
        minName: "4 CHARACTERS MINIMUM",
        emailExists: "E-MAIL ALREADY EXISTS",
        blockedRequests: "REQUESTS BLOCKED DUE TO UNUSUAL ACTIVITY. TRY AGAIN LATER",
        genericError: "ERROR PROCESSING REQUEST",
        createdAccount: "ACCOUNT CREATED SUCCESFFULLY",
        wrongCredentials: "WRONG CREDENTIALS",
        welcome: "WELCOME",
        name: "NAME",
        logInProfile: "LOG IN TO SEE YOUR PROFILE",
        goodbye: "GOODBYE",
        userLoggedOut: "USER LOGGED OUT",
        weather: "WEATHER",
        locationPermissionDenied: "PERMISSION TO ACCESS LOCATION DENIED",
        cameraPermissionDenied: "PERMISSION TO ACCESS CAMERA DENIED",
        cameraFsError: "ERROR SAVING FILE",
        location: "LOCATION",
        feels: "FEELS",
        humidity: "HUMIDITY",
        inputLocation: "ENTER LOCATION",
        close: "CLOSE",
        search: "SEARCH",
        searchError: "LOCATION NOT FOUND",
        inputUsername: "ENTER USERNAME",
        inputAvatar: "SELECT AVATAR",
        forecast: "FORECAST",
        calculator: "CALCULATOR",
        album: "ALBUM",
        noImg: "NO IMAGES TO DISPLAY",
        tryMobile: "MOBILE APP",
        downloadApk: "DOWNLOAD APK",
        refreshUser: "REFRESH DATA",
        editTask: "EDIT TASK",
        enterTask: "ENTER TASK",
        max: "MAX"
    }
}, {
    id: 2, lang: "spanish", text: {
        toDoList: "LISTA DE TAREAS",
        memoGame: "JUEGO MEMO",
        newGame: "NUEVO JUEGO",
        bestScore: "MEJOR RESULTADO",
        completed: "COMPLETADO",
        turns: "TURNOS",
        reset: "REINICIAR",
        add: "AGREGAR",
        newTask: "NUEVA TAREA",
        deleteTask: "ELIMINAR TAREA",
        deletePic: "ELIMINAR IMAGEN",
        cancel: "CANCELAR",
        delete: "ELIMINAR",
        email: "CORREO ELECTRÓNICO",
        name: "NOMBRE",
        password: "CONTRASEÑA",
        avatar: "AVATAR",
        language: "IDIOMA",
        darkMode: "MODO OSCURO",
        active: "ACTIVO",
        inactive: "INACTIVO",
        colorTheme: "TEMA DE COLOR",
        apps: "APPS",
        config: "CONFIG",
        profile: "PERFIL",
        spanish: "ESPAÑOL",
        english: "INGLÉS",
        purple: "PÚRPURA",
        orange: "NARANJA",
        logIn: "INGRESAR",
        logOut: "SALIR",
        signUp: "REGISTRARSE",
        minEmail: "EJEMPLO@DOMINIO.COM",
        minPassword: "8 CARACTERES MÍNIMO",
        minName: "4 CARACTERES MÍNIMO",
        emailExists: "CORREO YA EXISTE",
        blockedRequests: "SOLICITUDES BLOQUEDAS DEBIDO A ACTIVIDAD INUSUAL. INTENTE MÁS TARDE",
        genericError: "ERROR GENERANDO SOLICITUD",
        createdAccount: "CUENTA CREADA EXITOSAMENTE",
        wrongCredentials: "CREDENCIALES INVÁLIDAS",
        welcome: "BIENVENIDO/A",
        name: "NOMBRE",
        logInProfile: "INGRESA PARA VER TU PERFIL",
        goodbye: "ADIOS",
        userLoggedOut: "USUARIO DESLOGUEADO",
        weather: "CLIMA",
        locationPermissionDenied: "PERMISO PARA ACCEDER A LA LOCACIÓN DENEGADO",
        cameraPermissionDenied: "PERMISO PARA ACCEDER A LA CÁMARA DENEGADO",
        cameraFsError: "ERROR GUARDANDO ARCHIVO",
        location: "LOCACIÓN",
        feels: "S.T.",
        humidity: "HUMEDAD",
        inputLocation: "INGRESE UBICACIÓN",
        close: "CERRAR",
        search: "BUSCAR",
        searchError: "UBICACIÓN NO ENCONTRADA",
        inputUsername: "INGRESE NOMBRE",
        inputAvatar: "SELECCIONE AVATAR",
        forecast: "PRONÓSTICO",
        calculator: "CALCULADORA",
        album: "ÁLBUM",
        noImg: "NO HAY IMÁGENES PARA MOSTRAR",
        tryMobile: "APP MÓVIL",
        downloadApk: "DESCARGAR APK",
        refreshUser: "REFRESCAR DATOS",
        editTask: "EDITAR TAREA",
        enterTask: "INGRESAR TAREA",
        max: "MÁX"
    }
}]